// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login/login';
import forgetPassword from '@/views/login/ForgetPassword';
import register from '@/views/login/register';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Product';
import productapply from '@/views/goods/ProductApplyRecord';
/**
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/personal/user';

import password from '@/views/personal/password';
import mobilechange from '@/views/personal/mobilechange';
import emailchange from '@/views/personal/emailchange';
/**
 * 数据监控
 */
// 仪表盘界面主页
import Dashboard from '@/views/dashboard/Dashboard';
import AiKeyword from '@/views/ai/writer/keyword';
import AiArticle from '@/views/ai/writer/article';
import AiConfig from '@/views/ai/writer/config';
import AiPublish from '@/views/ai/writer/publish';
import AiSensitive from '@/views/ai/writer/sensitive';


import Mytodo from '@/views/workorder/Mytodo';


// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    mode: "history",
    routes: [{
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/login/forgetPassword',
        name: '忘记密码',
        component: forgetPassword,
        meta: {
            requireAuth: false
        }
    },{
        path: '/register',
        name: '注册',
        component: register,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/',
        name: '首页',
        component: index,
        redirect: '/dashboard',
        iconCls: 'el-icon-tickets',
        meta: {
            requireAuth: false
        },
        children: [{
            path: '/dashboard',
            name: '仪表盘',
            component: Dashboard,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/product',
            name: '产品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },  {
            path: '/orders',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/personal/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/personal/password',
            name: '密码修改',
            component: password,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/personal/mobilechange',
            name: '手机号修改',
            component: mobilechange,
            meta: {
                requireAuth: true 
            }
        }, {
            path: '/personal/emailchange',
            name: '邮箱修改',
            component: emailchange,
            meta: {
                requireAuth: true
            }
        },{
            path: '/apply',
            name: '我的申请',
            component: productapply,
            meta: {
                requireAuth: true
            }
        },{
            path: '/ai/keyword',
            name: '智能标题',
            component: AiKeyword,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/ai/article',
            name: '智能写作',
            component: AiArticle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/ai/config',
            name: '发布配置',
            component: AiConfig,
            meta: {
                requireAuth: true
            }
        },{
            path: '/ai/publish',
            name: '发布任务',
            component: AiPublish,
            meta: {
                requireAuth: true
            }
        },{
            path: 'ai/word/sensitive',
            name: '敏感词设置',
            component: AiSensitive,
            meta: {
                requireAuth: true
            }
        },{
            path: '/workorder/todo',
            name: '工作流',
            component: Mytodo,
            meta: {
                requireAuth: true
            }
        }  ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js